// Imports
import { empresa } from "../index";


//------------------------- Inicia P2P Sucripcion Tarjeta -------------------------
export const tramaSuscripcionTarjetaP2P = (params) =>{
    const trama = {
        // datos generales
        empresa : empresa,
        id_referencia: params.idPoliza,
        monto: '1.00',
        plataforma: 'WEB',
        ipAddress: params.cliIp,
        userAgent: 'PostmanRuntime/7.26.1',
        impuestos: '1.2',
        subtotal:'1.20',
        // datos del pagador
        buyer:{
            nombre: params.nombre,
            apellido: params.apellido,
            email: params.email,
            identificacion: params.identificacion,
            tipoDocumento: params.tipoDocumento,
            celular: params.celular
        }
    }
    return trama;
}
//------------------------- Termina P2P Sucripcion Tarjeta -------------------------